import { defaultHttpClient } from '../../httpClient';
import type { GetProductCategoryMeasureValuesResponse } from './types';

export const getProductCategoryMeasureValues = (
  productCategorySno: number,
) => {
  return defaultHttpClient
    .request<GetProductCategoryMeasureValuesResponse>({
      method: 'GET',
      url: `/api/v2/members/me/product-categories/${productCategorySno}/measure-values/`,
    })
    .then(result => result.data);
};
